<template>
  <div class="row align-items-stretch custom-card mt-4" v-if="item">
    <div class="col-md-4 p-0 d-flex">
      <img :src="item.image_path" class="img-fluid card-img" />
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5
          class="fw-bold"
          v-html="
            this.$i18n.locale == 'ar'
              ? item.translations[0].title
              : item.translations[1].title
          "
        ></h5>
        <p v-html="truncatedContent"></p>
        <button class="btn btn-primary">
          {{ $t("home.last_news.learn_more") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    truncatedContent() {
      const content =
        this.$i18n.locale == "ar"
          ? this.item.translations[0].content
          : this.item.translations[1].content;

      const words = content.split(" "); // Split text into words
      const maxWords = 40; // Set max words limit

      if (words.length > maxWords) {
        return words.slice(0, maxWords).join(" ") + "..."; // Truncate and add ellipsis
      }
      return content;
    },
  },
};
</script>

<style scoped>
.custom-card {
  background-color: #faf7ef;
  border-radius: 15px;
  overflow: hidden;
}

.custom-card .card-body {
  padding: 20px;
  padding-top: 40px;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

h5 {
  font-size: 28px;
  font-weight: 500;
}

p {
  font-size: 24px;
  font-weight: 400;
  margin-top: 40px;
}

.btn {
  margin-top: 40px;
}
</style>
